/**
 * Store locations for in-store proximity detection.
 *
 * Production: set REACT_APP_STORE_LOCATIONS_API_URL to a JSON endpoint that returns
 * an array of { id, name, latitude, longitude, proximityRadiusMeters? }.
 */

/** Default proximity radius when a store does not define its own (meters). */
export const DEFAULT_STORE_PROXIMITY_RADIUS_METERS = 100;

/**
 * Store locations — replace coordinates with real retail sites.
 */
export const DEFAULT_STORE_LOCATIONS = [
  // {
  //   id: "store-downtown-001",
  //   name: "Orbiee Downtown",
  //   latitude: 26.435094253559395,
  //   longitude: 80.33244589724922,
  //   proximityRadiusMeters: DEFAULT_STORE_PROXIMITY_RADIUS_METERS,
  // },
  {
    id: "store-downtown-001",
    name: "Orbiee Downtown",
    latitude: 26.435094253559395,
    longitude: 80.33244589724922,
    proximityRadiusMeters: DEFAULT_STORE_PROXIMITY_RADIUS_METERS,
  }
];

export const STORE_LOCATIONS_API_URL =
  process.env.REACT_APP_STORE_LOCATIONS_API_URL || "";

/** Only simulates in-store position when explicitly enabled. */
export const FORCE_NEAR_STORE_FOR_TESTING =
  process.env.REACT_APP_FORCE_NEAR_STORE_FOR_TESTING === "true";

/** How long cached user position / proximity results stay valid (ms). */
export const USER_LOCATION_CACHE_TTL_MS = 5 * 60 * 1000;

/** Max wait for browser geolocation before falling back (ms). */
export const GEOLOCATION_TIMEOUT_MS = 8000;
